/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import roleApi from "@/apis/UserSystem/UserAPI.js";
const actions = {
  // hàm disabledRole
  disabledRole({ commit }) {
    commit("DISABLED_ROLE");
  },
  // Mở disableRole
  undisabledRole({ commit }) {
    commit("UNDISABLED_ROLE");
  },

  async updateRoleLocal(context, payload) {
    let res = await roleApi.getListUserRole();
    let roleData = [];
    if (res) {
      roleData = res.map((c) => {
        return c.name;
      });
    } else {
      roleData = [];
    }
    context.commit("updateRoleLocal", roleData);
  },

  // getMerchant({ commit }, payload) {
  //   commit("GET_MERCHANTS", payload)
  // }

  //Các hàm phục vụ cho thu hộ doanh nghiệp
  setCustomersList({ commit }, payload) {
    commit("setCustomersList", payload);
  },

  setItemCustomersList({ commit }, payload) {
    commit("setItemCustomersList", payload);
  },

  setCurrentPeriod({ commit }, payload) {
    commit("setCurrentPeriod", payload);
  },
  setRangeDate({ commit }, value) {
    commit("setRangeDate", value);
  },
};

export default actions;
